import dayjs from 'dayjs'
import { useState } from 'react'
import Header from 'src/common/components/Header/Header'
import TokenSelector from 'src/common/components/TokenSelector/TokenSelector'
import useToggle from 'src/common/hooks/helpers/useToggle'
import Badge from 'src/common/ui-kit/Badge'
import Button from 'src/common/ui-kit/Button/Button'
import Checkbox from 'src/common/ui-kit/Checkbox/Checkbox'
import DateTimePicker from 'src/common/ui-kit/Date/DateTimePicker'
import Icon from 'src/common/ui-kit/Icon/Icon'
import NumericField from 'src/common/ui-kit/NumericField/NumericField'
import OvalBadge from 'src/common/ui-kit/OvalBadge'
import RadioButton from 'src/common/ui-kit/RadioButton/RadioButton'
import RadioButtonGroup from 'src/common/ui-kit/RadioButton/RadioButtonGroup'
import Option from 'src/common/ui-kit/Select/Option'
import OptionSubheader from 'src/common/ui-kit/Select/OptionSubheader'
import Select from 'src/common/ui-kit/Select/Select'
import Switch from 'src/common/ui-kit/Switch/Switch'
import TextField from 'src/common/ui-kit/TextField/TextField'

const UiDev = () => {
  const [radioButtonGroupValue, setRadioButtonGroupValue] = useState(1)

  const [int, setInt] = useState(0)
  const [float, setFloat] = useState(0)
  const [floatWithMax, setFloatWithMax] = useState(0)

  const [network, setNetwork] = useState<string>('')
  const networkIds = ['1', '137']
  const switchNetwork = (value: string) => {
    if (networkIds.includes(value)) {
      setNetwork(value)
    }
  }

  const { isOn, toggle } = useToggle()
  const { isOn: switchChecked, toggle: toggleSwitch } = useToggle()

  return (
    <>
      <div className='mb-5'>
        <Header />
      </div>
      {/* <button className="bg-primary-faded"></button> */}
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <Button color='primary' variant='contained' size='md'>
            Contained
          </Button>
          <Button color='secondary' variant='contained' size='md'>
            Secondary Contained
          </Button>
          <Button color='primary' variant='outlined' size='md'>
            Outlined
          </Button>
          <Button color='primary' variant='text' size='md'>
            Text
          </Button>
          <Button disabled variant='contained' size='md'>
            Contained Disabled
          </Button>
          <Button disabled variant='outlined' size='md'>
            Outlined Disabled
          </Button>
          <Button disabled variant='text' size='md'>
            Text Disabled
          </Button>
          <Button variant='contained' size='sm'>
            Small
          </Button>
          <Button variant='contained' size='md'>
            Medium
          </Button>
          <Button variant='contained' size='lg'>
            Large
          </Button>
          <Button
            className='py-2'
            variant='contained'
            size='md'
            StartAdornment={<span>🌟</span>}
            EndAdornment={<span>✔️</span>}
          >
            Icons
          </Button>
        </div>
        <div
          style={{
            display: 'flex',
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
            gap: 15,
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            <TextField size='sm' inputProps={{ placeholder: 'Type message' }} />
            <TextField
              size='sm'
              StartAdornment={<span>🌟</span>}
              EndAdornment={<span>✔️</span>}
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              size='sm'
              errorMessage='Error message'
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField inputProps={{ placeholder: 'Type message' }} />
            <TextField
              StartAdornment={<span>🌟</span>}
              EndAdornment={<span>✔️</span>}
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              errorMessage='Error message'
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField size='lg' inputProps={{ placeholder: 'Type message' }} />
            <TextField
              size='lg'
              StartAdornment={<span>🌟</span>}
              EndAdornment={<span>✔️</span>}
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              size='lg'
              errorMessage='Error message'
              inputProps={{ placeholder: 'Type message' }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            <TextField
              variant='text'
              size='sm'
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              variant='text'
              size='sm'
              StartAdornment={<span>🌟</span>}
              EndAdornment={<span>✔️</span>}
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              variant='text'
              size='sm'
              errorMessage='Error message'
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              variant='text'
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              variant='text'
              StartAdornment={<span>🌟</span>}
              EndAdornment={<span>✔️</span>}
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              variant='text'
              errorMessage='Error message'
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              variant='text'
              size='lg'
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              variant='text'
              size='lg'
              StartAdornment={<span>🌟</span>}
              EndAdornment={<span>✔️</span>}
              inputProps={{ placeholder: 'Type message' }}
            />
            <TextField
              variant='text'
              size='lg'
              errorMessage='Error message'
              inputProps={{ placeholder: 'Type message' }}
            />
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <RadioButton label='Disabled' disabled />
          <RadioButton label='Checked' defaultChecked />
          <RadioButton label='Not checked' />
          <RadioButton />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <RadioButtonGroup
            value={radioButtonGroupValue}
            onChange={value => setRadioButtonGroupValue(value as number)}
          >
            <RadioButton label='First' value={1} />
            <RadioButton label='Second' value={2} />
            <RadioButton label='Third' value={3} />
          </RadioButtonGroup>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <Switch onChange={toggleSwitch} checked={switchChecked} />
          <Switch disabled />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <Select onChange={switchNetwork} value={network}>
            <OptionSubheader>Networks</OptionSubheader>
            <Option value={'1'}>Ethereum</Option>
            <Option value={'137'}>Polygon</Option>
            <hr className='my-2' />
            <Option value={'Polygonlink'}>Polygon Bridge</Option>
            <Option value={'Baselink'}>Base Bridge</Option>
          </Select>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <Icon cdn name='SwarmMobileLogo' />
          <Icon name='external-link' />
          <Icon name='certified' />
          <Icon name='chart' />
          <Icon name='check' />
          <Icon name='delete' />
          <Icon name='duplicate' />
          <Icon name='export' />
          <Icon name='info' />
          <Icon name='list' />
          <Icon name='menu' />
          <Icon name='more' />
          <Icon name='search' />
          <Icon name='settings' />
          <Icon name='share' />
          <Icon name='show' />
          <Icon name='wallet' />
          <Icon name='swap' />
          <Icon name='bolt-outlined' />
          <Icon name='star-filled' />
          <Icon name='star-outlined' />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <Badge size='md' color='secondary'>
            5%
          </Badge>
          <Badge active size='md' color='secondary'>
            5%
          </Badge>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <Checkbox checked={isOn} onChange={toggle} />
          <Checkbox defaultChecked />
          <Checkbox defaultChecked disabled />
          {/* <Checkbox
            CheckedIcon={<Icon name={'star-filled'} stroke='white' />}
            UncheckedIcon={<Icon name={'star-outlined'} stroke='white' />}
          /> */}
          <Checkbox
            checked={isOn}
            onChange={toggle}
            noIconStyle
            CheckedIcon={<Icon size='24px' name={'star-filled'} />}
            UncheckedIcon={<Icon size='24px' name={'star-outlined'} />}
          />
        </div>
        <div
          style={{
            width: '600px',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <div>
            <span>Float + Decimals 6</span>
            <NumericField
              type='number'
              value={int}
              onChange={setInt}
              mode='float'
              maxDecimals={6}
            />
          </div>
          <div>
            <span>Integer (no decimals) + Max Value 100. + Min Value 0</span>
            <NumericField
              type='number'
              value={float}
              onChange={setFloat}
              mode='integer'
              maxDecimals={6}
              maxValue={100}
              minValue={0}
            />
          </div>
          <div>
            <span>Float + Decimals 6 + Max Value 1000.000002</span>
            <NumericField
              type='number'
              value={floatWithMax}
              onChange={setFloatWithMax}
              mode='float'
              maxDecimals={6}
              maxValue={1000.000002}
              minValue={0}
            />
          </div>
        </div>
        <div
          style={{
            width: '600px',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <Button>Open modal</Button>
          <TokenSelector onChange={() => {}} />
          {/* <Modal open={true}>asdasdasdasdasdasdasdasds</Modal> */}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '600px',
            gap: 10,
            padding: 10,
            border: 'solid 1px',
            background: '#fff',
          }}
        >
          <OvalBadge className='max-w-20 h-min'>Active</OvalBadge>
          <OvalBadge className='max-w-20 h-min' active>
            Inactive
          </OvalBadge>
          <Badge className='h-min'>Badge</Badge>
        </div>
        <div className='min-h-screen flex items-center justify-center bg-gray-100 p-4'>
          <DateTimePicker
            initialDate={dayjs()}
            onDateChange={newDate =>
              console.log(
                'Selected Date and Time:',
                newDate.format('YYYY-MM-DD HH:mm')
              )
            }
            minDate={dayjs()}
            maxDate={dayjs().add(1, 'month')}
          />
        </div>
      </div>
    </>
  )
}

export default UiDev
